import { Div2Floor } from "./Div2Floor";

export function CenterIt(spaceSize, elementSize) {
  return Div2Floor(spaceSize - elementSize);
  //return Math.floor((spaceSize-elementSize)/2);
}
